import { CircleCheck, CircleHelp, CircleX, FileCheck2, ShieldAlert, ShieldCheck, ShieldQuestion, TriangleAlert } from "lucide-react";
import type { Tone } from "@/components/app-shell/lists/table-box";
import type { SignatureStatus } from "@/modules/documents";

const GREEN = { row: "", chip: "border-success/50 bg-success/10 text-success", iconColour: "text-success" };
const YELLOW = { row: "", chip: "border-warning/50 bg-warning/10 text-warning", iconColour: "text-warning" };
const RED = { row: "", chip: "border-destructive/50 bg-destructive/10 text-destructive", iconColour: "text-destructive" };

/** The badge of a signed PDF: green valid, yellow integrity ok but the certificate is not on the lists (untrusted) or the lists were not available (unchecked), red changed after signing or signature not valid. */
export const SIGNATURE_TONES: Record<SignatureStatus, Tone> = {
  valid: { icon: ShieldCheck, ...GREEN },
  untrusted: { icon: ShieldQuestion, ...YELLOW },
  unchecked: { icon: ShieldQuestion, ...YELLOW },
  changed: { icon: ShieldAlert, ...RED },
  invalid: { icon: ShieldAlert, ...RED },
};

/** The "Signed" badge next to a version in the Files list and its history. */
export const SIGNED_VERSION_TONE: Tone = { icon: FileCheck2, ...GREEN };

export type Mark = "good" | "bad" | "warn" | "neutral";

/** The chip of one line in the signature panel; every mark has its own icon so the state never rests on colour alone. */
export const MARK_TONES: Record<Mark, Tone> = {
  good: { icon: CircleCheck, ...GREEN },
  bad: { icon: CircleX, ...RED },
  warn: { icon: TriangleAlert, ...YELLOW },
  neutral: { icon: CircleHelp, row: "", chip: "border-border bg-muted text-muted-foreground", iconColour: "text-muted-foreground" },
};
